import React, { useMemo } from 'react';

import { Elaborate } from 'assets/assetsV1/iconComponents/Elaborate';
import { FixGrammar } from 'assets/assetsV1/iconComponents/FixGrammar';
import { Rephrase } from 'assets/assetsV1/iconComponents/Rephrase';
import { Shorten } from 'assets/assetsV1/iconComponents/Shorten';

import { SplitButton } from 'uiToolkitV1/SplitButton';

import { RephraseOption } from './types';

export interface RephraseOptionsProps {
  handleRephraseText: (value: RephraseOption, loadingText: string) => void;
  tooltipText: string;
  totalCharacters?: number;
  isDisabled?: boolean;
}

export const RephraseOptions = ({
  handleRephraseText,
  tooltipText,
  totalCharacters,
  isDisabled,
}: RephraseOptionsProps) => {
  const rephraseOptions = useMemo(
    () => [
      {
        value: 'improve_writing',
        label: 'Rephrase',
        onClick: () => handleRephraseText('improve_writing', 'Rephrasing your moduleName comment'),
        icon: Rephrase,
        tooltipText,
      },
      {
        value: 'shorten',
        label: 'Shorten',
        onClick: () => handleRephraseText('shorten', 'Shortening your moduleName comment'),
        icon: Shorten,
        tooltipText:
          totalCharacters < 150
            ? 'At least 150 characters are needed for this feature to function optimally. This ensures Maven gains ample context to deliver a meaningful and tailored response.'
            : '',
        isDisabled: totalCharacters < 150,
      },
      {
        value: 'elaborate',
        label: 'Elaborate',
        onClick: () => handleRephraseText('elaborate', 'Elaborating your moduleName comment'),
        icon: Elaborate,
        tooltipText:
          totalCharacters < 150
            ? 'At least 150 characters are needed for this feature to function optimally. This ensures Maven gains ample context to deliver a meaningful and tailored response.'
            : '',
        isDisabled: totalCharacters < 150,
      },
      {
        value: 'fix_spelling_grammar',
        label: 'Fix Grammar & Spelling',
        onClick: () =>
          handleRephraseText('fix_spelling_grammar', 'Fixing the spelling and grammar for your moduleName comment'),
        // eslint-disable-next-line react/no-unstable-nested-components
        icon: (props) => <FixGrammar fill="none" {...props} />,
      },
    ],
    [handleRephraseText, tooltipText, totalCharacters]
  );

  return (
    // @ts-expect-error requires more props
    <SplitButton
      isGradient
      options={rephraseOptions}
      isDisabled={isDisabled}
      indexesToRender={[1, 2, 3]}
      minWidth={200}
    />
  );
};
